<template>
  <div class="page-wrap">
    <PageHeader
      title="견적 발급"
      subtitle="견적에 필요한 정보 입력 후, 메일을 통해 견적서 PDF 파일을 전송할 수 있습니다."
    />

    <!-- 1) 학교 검색 -->
    <FormCard header="학교 검색">
      <div class="field-group">
        <label class="field-label">
          학교 선택 <span class="field-required">(필수)</span>
        </label>
        <div class="search-row">
          <div class="search-row__input">
            <v-autocomplete
              @keyup.enter="schoolsearch()"
              auto-select-first
              append-inner-icon="mdi-magnify"
              item-props
              density="compact"
              menu-icon=""
              variant="outlined"
              v-model="searchschool"
              :items="searchlist"
              color="primary"
              placeholder="학교를 검색해주세요."
              spellcheck="false"
              theme="light"
              hide-details="auto"
            />
          </div>
          <v-btn
            variant="flat"
            color="primary"
            class="btn-primary"
            @click="schoolsearch()"
          >검색</v-btn>
        </div>
        <p v-if="schoolerror" class="field-error">
          <v-icon icon="mdi-close-circle-outline" size="14" />
          {{ schoolerror }}
        </p>
        <p v-else class="field-helper">
          검색 후 Enter 키 또는 검색 버튼으로 학교를 확정하세요.
        </p>
      </div>
    </FormCard>

    <!-- 2) 견적 내용 작성 -->
    <FormCard header="견적 내용 작성">
      <div class="form-row">
        <div class="field-group field-group--inline">
          <label class="field-label">
            계약 개월수 <span class="field-required">(필수)</span>
          </label>
          <v-text-field
            v-model="contractmonth"
            type="text"
            density="compact"
            variant="outlined"
            placeholder="숫자를 입력해주세요."
            hide-details="auto"
          />
          <p v-if="montherror" class="field-error">
            <v-icon icon="mdi-close-circle-outline" size="14" />
            {{ montherror }}
          </p>
        </div>

        <div class="field-group field-group--inline">
          <label class="field-label">
            계약 학생수 <span class="field-required">(필수)</span>
          </label>
          <v-text-field
            v-model="contractamount"
            type="text"
            density="compact"
            variant="outlined"
            placeholder="숫자를 입력해주세요."
            hide-details="auto"
          />
          <p v-if="amounterror" class="field-error">
            <v-icon icon="mdi-close-circle-outline" size="14" />
            {{ amounterror }}
          </p>
        </div>

        <div class="field-group field-group--inline">
          <label class="field-label">
            요금 플랜 <span class="field-required">(필수)</span>
          </label>
          <v-select
            v-model="plan"
            :items="planOptions"
            item-title="label"
            item-value="value"
            density="compact"
            variant="outlined"
            placeholder="요금 플랜을 선택해주세요"
            hide-details="auto"
          />
          <p v-if="planerror" class="field-error">
            <v-icon icon="mdi-close-circle-outline" size="14" />
            {{ planerror }}
          </p>
        </div>
      </div>

      <template #footer>
        <v-btn
          variant="outlined"
          color="default"
          class="btn-secondary"
          @click="caculatemoney()"
        >확인</v-btn>
      </template>
    </FormCard>

    <!-- 3) 견적 확인 -->
    <FormCard header="견적 확인">
      <div class="field-group">
        <label class="field-label">견적 결과</label>
        <div class="result-row">
          <v-text-field
            v-model="totalmoney"
            disabled
            density="compact"
            variant="outlined"
            placeholder="금액"
            hide-details="auto"
            class="result-row__amount"
          />
          <div class="result-row__desc">
            <p class="result-row__line">
              <span class="num">{{ contractmonth || 0 }}</span>개월 X
              <span class="num">{{ contractamount || 0 }}</span>명 X
              <span class="num">{{ money_per || 0 }}</span>원 =
              <span class="num">{{ showmoney || 0 }}</span>원
            </p>
            <p class="result-row__line">
              <span class="num">{{ real_money_per || 0 }}</span>원 단위 절삭 =
              <span class="num">{{ realmoney || 0 }}</span>원
            </p>
          </div>
        </div>
      </div>

      <div class="field-group">
        <label class="field-label">
          견적 최종액 입력 <span class="field-required">(필수)</span>
        </label>
        <div class="final-row">
          <v-text-field
            v-model="realmoney"
            :disabled="estimateflag"
            density="compact"
            variant="outlined"
            placeholder="숫자를 입력해주세요."
            hide-details="auto"
            class="final-row__amount"
          />
        </div>
        <p v-if="lastmoneyerror" class="field-error">
          <v-icon icon="mdi-close-circle-outline" size="14" />
          {{ lastmoneyerror }}
        </p>
      </div>

      <template #footer>
        <v-btn
          v-if="!estimateflag"
          variant="flat"
          color="primary"
          class="btn-primary"
          @click="goestimate()"
        >발급하기</v-btn>
        <v-btn
          v-else
          variant="flat"
          color="primary"
          class="btn-primary"
          disabled
        >발급하기</v-btn>
        <v-btn
          v-if="estimateflag"
          variant="outlined"
          color="default"
          class="btn-secondary"
          @click="estimateinit()"
        >견적 초기화</v-btn>
      </template>
    </FormCard>

    <!-- 4) 견적 보내기 -->
    <FormCard header="견적 보내기">
      <div class="field-group">
        <label class="field-label">견적 및 연락처 정보 확인</label>
        <div class="info-table-wrap">
          <table class="info-table">
            <thead>
              <tr>
                <th>no.</th>
                <th>요금플랜</th>
                <th>개월수</th>
                <th>학생수</th>
                <th>추가 할인액</th>
                <th>견적 최종가</th>
                <th>견적일시</th>
                <th>담당자 ID</th>
                <th>선택</th>
                <th>다운로드</th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="estimatelist.length === 0">
                <td colspan="10" class="empty-row">발급된 견적이 없습니다.</td>
              </tr>
              <tr v-for="(j, i) in estimatelist" :key="i">
                <td class="num">{{ i + 1 }}</td>
                <td>{{ getplanstring(j.plan) }}</td>
                <td class="num">{{ j.period }}</td>
                <td class="num">{{ j.quantity }}</td>
                <td class="num">{{ getlocalestring(j.discount) }}</td>
                <td class="num strong">{{ getlocalestring(j.price - j.discount) }}</td>
                <td class="mono">{{ j.time }}</td>
                <td class="mono">{{ j.manager }}</td>
                <td>
                  <input v-model="j.isSelected" type="checkbox" />
                </td>
                <td>
                  <v-btn
                    size="small"
                    variant="outlined"
                    color="success"
                    @click="downloadestimate(j.idx)"
                  >다운로드</v-btn>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div class="field-group">
        <label class="field-label">발송 대상 연락처</label>
        <div class="info-table-wrap">
          <table class="info-table">
            <thead>
              <tr>
                <th>이름</th>
                <th>이메일주소</th>
                <th>전화번호</th>
                <th>메모</th>
                <th>메일</th>
                <th>문자</th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="contactlist.length === 0">
                <td colspan="6" class="empty-row">학교를 먼저 검색해주세요.</td>
              </tr>
              <tr v-for="(j, i) in contactlist" :key="i">
                <td>{{ j.name }}</td>
                <td class="mono">{{ j.mail }}</td>
                <td class="mono">{{ j.tel }}</td>
                <td>{{ j.memo || "-" }}</td>
                <td><input v-model="j.mailCheck" type="checkbox" /></td>
                <td><input v-model="j.telCheck" type="checkbox" /></td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <template #footer>
        <v-btn
          variant="flat"
          color="primary"
          class="btn-primary"
          @click="sendmail()"
        >발송하기</v-btn>
      </template>
    </FormCard>

    <!-- PDF 미리보기 (백엔드에서 받은 HTML) - 절대 손대지 말 것 -->
    <div id="estimatedoc" v-if="sample_html" class="preview-wrap">
      <p class="preview-label">미리보기 (클릭 시 확대)</p>
      <div
        @click="estimate_full()"
        v-html="sample_html"
        style="cursor: pointer; width: 700px; zoom: 0.35"
      ></div>
    </div>

    <!-- 견적서 미리보기 다이얼로그 - PDF 캡쳐 원본 영역, 손대지 말 것 -->
    <v-dialog v-model="fullmodal" width="1000" height="1000">
      <v-card width="1000" height="1100">
        <div v-html="sample_html" style="zoom: 0.85"></div>
      </v-card>
    </v-dialog>

    <!-- 알림 다이얼로그 1 -->
    <v-dialog v-model="alimmodal" width="420">
      <v-card class="alert-dialog">
        <div class="alert-dialog__header">알림</div>
        <div class="alert-dialog__body">
          <p>
            {{ real_money_per }}원 단위 구매가 불가한 금액입니다. '학교장터'가
            아닌 '계좌이체' 진행 학교가 맞는지 확인해주세요. 이대로 견적을
            발급하려면 확인 버튼을 눌러주세요.
          </p>
        </div>
        <div class="alert-dialog__footer">
          <v-btn variant="outlined" color="default" class="btn-secondary" @click="reallycancel()">취소</v-btn>
          <v-btn variant="flat" color="primary" class="btn-primary" @click="reallycheck()">확인</v-btn>
        </div>
      </v-card>
    </v-dialog>

    <!-- 알림 다이얼로그 2 -->
    <v-dialog v-model="alimalimmodal" width="420">
      <v-card class="alert-dialog">
        <div class="alert-dialog__header">알림</div>
        <div class="alert-dialog__body">
          <p>견적 결과와 최종액이 다릅니다.<br />이대로 발급 하시겠습니까?</p>
        </div>
        <div class="alert-dialog__footer">
          <v-btn variant="outlined" color="default" class="btn-secondary" @click="reallyreallycancel()">취소</v-btn>
          <v-btn variant="flat" color="primary" class="btn-primary" @click="reallyreallycheck()">확인</v-btn>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import dayjs from "dayjs";
import {
  changeschoolpaystatus,
} from "@/api/user-api-list";
import PageHeader from "@/components/ui/PageHeader.vue";
import FormCard from "@/components/ui/FormCard.vue";

export default {
  components: { PageHeader, FormCard },
  data() {
    return {
      searchschool: null,
      schoolname: "",
      contractmonth: "",
      contractamount: "",
      fullmoney: "",
      totalmoney: "",
      realmoney: "",
      real_money_per: "",
      money_per: "",
      estimate_date: "",
      expire_date: "",
      fullmodal: false,
      alimmodal: false,
      alimalimmodal: false,
      estimateflag: false,
      schoolerror: "",
      montherror: "",
      amounterror: "",
      lastmoneyerror: "",
      realrealmoney: "",
      onlyaccount: false,
      fullmodaltwo: false,
      showmoney: "",
      moneyexpire: "",
      plan: "",
      planerror: "",
      money_per_discount: 0,
      discounttext: "",
      money_per_num: "",
      estimate_url: "",
      estimate_idx: "",
      sample_html: "",
      schoolcode: "",
      contactlist: [],
      count: {
        mail: { good: [], bad: [] },
        sms: { good: [], bad: [] },
      },
      isestimate: false,
      searchdata: "",
      searchlist: [],
      searchcandidate: "",
      estimatelist: [],
      planOptions: [
        { label: "일반 플랜", value: "general" },
        { label: "프리미엄 플랜", value: "premium" },
      ],
    };
  },
  async created() {
    const res = await this.$store.dispatch("GET_SEARCH_LIST");
    this.searchdata = res;
    this.searchlist = Object.getOwnPropertyNames(res);
  },
  methods: {
    async estimateRegister() {
      const price =
        this.contractmonth * this.contractamount * this.real_money_per;
      const discount =
        this.contractmonth * this.contractamount * this.money_per_num;

      let realmoney_num = this.realmoney.replace(/,/g, "");

      const real_money = parseInt(realmoney_num);
      const final_money = discount;
      const remain = this.getremain(real_money, this.real_money_per);

      const data = {
        teachername: "담당",
        schoolName: this.schoolname.trim(),
        schoolCode: this.schoolcode,
        period: parseInt(this.contractmonth),
        quantity: parseInt(this.contractamount),
        price,
        discount: price - discount,
        plan: this.plan,
        money_per_discount: this.money_per_discount,
        discount_text: this.discounttext,
        final_money,
        real_money,
        remain,
        money_expire: this.moneyexpire,
        money_per: this.real_money_per,
        manager: sessionStorage.getItem("id"),
      };

      const res = await this.$store.dispatch("ESTIMATE_REGISTER", data);

      const res2 = await this.$store.dispatch("GET_ESTIMATE_SAMPLE", {
        type: this.plan,
        remain,
        data,
      });

      this.sample_html = res2;

      this.estimate_url = `https://kr.object.gov-ncloudstorage.com/dn-bucket/estimate/${this.schoolcode}/${res}.pdf`;
      this.estimate_idx = res;

      const date = new Date();

      this.estimatelist.push({
        idx: res,
        plan: this.plan,
        period: parseInt(this.contractmonth),
        quantity: parseInt(this.contractamount),
        price,
        discount: price - discount,
        manager: sessionStorage.getItem("id"),
        isSelected: false,
        time: `${date.getFullYear()}-${(date.getMonth() + 1)
          .toString()
          .padStart(2, "0")}-${date
          .getDate()
          .toString()
          .padStart(2, "0")} ${date
          .getHours()
          .toString()
          .padStart(2, "0")}:${date
          .getMinutes()
          .toString()
          .padStart(2, "0")}:${date.getSeconds().toString().padStart(2, "0")}`,
      });

      return;
    },
    getremain(a, b) {
      if (a % b == 0) {
        return 1;
      } else {
        return 0;
      }
    },
    estimateinit() {
      this.totalmoney = "";
      this.realmoney = "";
      this.contractamount = "";
      this.contractmonth = "";
      this.sample_html = "";
      this.estimateflag = false;
      this.onlyaccount = false;
    },
    caculatemoney() {
      const amount = this.contractamount;
      const month = this.contractmonth;

      if (
        this.schoolname == "" ||
        this.searchschool == "" ||
        this.schoolcode == ""
      ) {
        this.schoolerror = "학교를 입력해주세요.";
      } else {
        this.schoolerror = "";
      }

      if (isNaN(month) || month == "") {
        this.montherror = "숫자만 입력해주세요.";
      } else {
        this.montherror = "";
      }

      if (!this.plan) {
        this.planerror = "요금 플랜을 선택해주세요.";
      } else {
        this.planerror = "";
      }

      if (isNaN(amount) || month == "") {
        this.amounterror = "숫자만 입력해주세요.";
        return;
      } else {
        this.amounterror = "";
      }

      this.schoolname = this.searchschool;
      this.schoolerror = "";
      this.amounterror = "";

      let money = 0;
      let money_ori = 0;

      if (this.plan == "premium") {
        this.real_money_per = 9000;
        money_ori = 9000;
        money = 9000;
      }

      if (this.plan == "general") {
        this.real_money_per = 6000;
        money_ori = 6000;
        money = 6000;
      }

      if (amount > 0 && amount < 100) {
        this.discounttext = "-";
        this.money_per_discount = 0;
      }

      if (amount >= 100 && amount < 400) {
        this.money_per_discount = money * 0.1;
        money = money * 0.9;
        this.discounttext = "100명 이상 결제 시, 10% 할인 적용";
      }

      if (amount >= 400 && amount < 700) {
        this.money_per_discount = money * 0.15;
        money = money * 0.85;
        this.discounttext = "400명 이상 결제 시, 15% 할인 적용";
      }

      if (amount >= 700) {
        this.money_per_discount = money * 0.2;
        money = money * 0.8;
        this.discounttext = "700명 이상 결제 시, 20% 할인 적용";
      }

      this.money_per_num = money;
      this.money_per = money.toLocaleString();

      const full = money * month * amount;
      const remain = full % money_ori;

      this.showmoney = full.toLocaleString();

      this.totalmoney = (full - remain).toLocaleString();
      this.realmoney = (full - remain).toLocaleString();

      let now = dayjs();

      this.estimate_date = dayjs(now, "YYYY-MM-DD").format().split("T")[0];

      this.expire_date = dayjs(
        now.add(this.contractmonth, "month"),
        "YYYY-MM-DD"
      )
        .format()
        .split("T")[0];

      this.moneyexpire = dayjs(now.add(1, "month"), "YYYY-MM-DD")
        .format()
        .split("T")[0];
    },
    estimate_full() {
      this.fullmodal = true;
    },
    goestimate() {
      if (!this.schoolname || !this.contractmonth || !this.contractamount) {
        this.lastmoneyerror = "견적 내용을 먼저 작성해주세요.";
        return;
      }

      if (isNaN(this.renum(this.realmoney))) {
        this.lastmoneyerror = "숫자만 입력해주세요.";
        return;
      }

      if (this.renum(this.realmoney) % this.real_money_per != 0) {
        this.alimmodal = true;
        return;
      } else {
        if (this.totalmoney != this.realmoney) {
          this.alimalimmodal = true;
          return;
        } else {
          this.estimateflag = true;

          this.realmoney = this.realmoney.toLocaleString();
        }
      }

      this.estimateRegister();
    },
    downloadestimate(idx) {
      setTimeout(() => {
        window.open(
          `https://argongadmin.argong.io/estimate/download?url=https://kr.object.gov-ncloudstorage.com/dn-bucket/estimate/${this.schoolcode}/${idx}.pdf&schoolName=${this.searchschool}`
        );
      }, 1000);
    },
    renum() {
      return this.realmoney.replace(/\D/g, "");
    },
    really() {
      this.alimmodal = true;
    },
    reallycheck() {
      if (this.totalmoney != this.realmoney) {
        this.alimmodal = false;
        this.onlyaccount = true;
        this.reallyreally();
      } else {
        this.alimmodal = false;

        this.estimateflag = true;
        this.onlyaccount = true;
        this.realmoney = this.realmoney.toLocaleString();
        this.estimateRegister();
      }
    },
    reallycancel() {
      this.alimmodal = false;
    },
    reallyreally() {
      this.alimalimmodal = true;
    },
    reallyreallycheck() {
      this.alimalimmodal = false;
      this.estimateflag = true;
      this.realmoney = this.realmoney.toLocaleString();
      this.estimateRegister();
    },
    reallyreallycancel() {
      this.alimalimmodal = false;
    },
    async searchSchoolCode() {
      this.schoolcode = "testCode01";
      this.contactlist = await this.$store.dispatch(
        "GET_SCHOOL_CONTACT",
        this.schoolcode
      );
      return;
    },
    async sendmail() {
      if (this.contactlist.length == 0) {
        alert("학교를 먼저 검색해주세요.");
        return;
      }
      let mail_contacts = this.contactlist.filter((a) => a.mailCheck == true);
      let tel_contacts = this.contactlist.filter((a) => a.telCheck == true);

      if (mail_contacts.length == 0 && tel_contacts.length == 0) {
        alert("연락처를 종류별로 하나 이상 선택해주세요");
        return;
      }

      let estimate_list = this.estimatelist.filter((a) => a.isSelected == true);

      if (estimate_list.length == 0) {
        alert("견적서를 선택해주세요.");
        return;
      }

      if (estimate_list.length > 1) {
        alert("견적서를 하나만 선택해주세요.");
        return;
      }

      let estimate_url = `https://argongadmin.argong.io/estimate/download?url=https://kr.object.gov-ncloudstorage.com/dn-bucket/estimate/${this.schoolcode}/${estimate_list[0].idx}.pdf&schoolName=${this.searchschool}`;

      for (let i = 0; i < this.contactlist.length; i++) {
        if (!this.contactlist[i].mailCheck) {
          continue;
        } else {
          const maildata = {
            email: this.contactlist[i].mail,
            name: this.contactlist[i].name,
            remain: this.getremain(
              parseInt(this.realmoney.replace(/,/g, "")),
              this.real_money_per
            ),
            estimate_url,
          };

          const res = await this.$store.dispatch(
            "SEND_ESTIMATE_MAIL",
            maildata
          );

          if (res == "good") {
            this.count.mail.good.push({
              name: this.contactlist[i].name,
              mail: this.contactlist[i].mail,
            });
          }

          if (res == "error") {
            this.count.mail.bad.push(this.contactlist[i].mail);
          }
        }
      }

      for (let i = 0; i < this.contactlist.length; i++) {
        if (!this.contactlist[i].telCheck) {
          continue;
        } else {
          const smsdata = {
            tel: this.contactlist[i].tel,
          };

          const res = await this.$store.dispatch("SEND_ESTIMATE_SMS", smsdata);

          if (res == "good") {
            this.count.sms.good.push({
              name: this.contactlist[i].name,
              tel: this.contactlist[i].tel,
            });
          }

          if (res == "error") {
            this.count.sms.bad.push(this.contactlist[i].tel);
          }
        }
      }

      const res3 = await changeschoolpaystatus({
        schoolCode: this.schoolcode,
        payStatus: "견적발급",
      });
      if (res3.data.data) {
        alert(
          `메일 전송 성공 : ${this.count.mail.good.length}건\n메일 전송 실패 : ${this.count.mail.bad.length}건\n문자 전송 성공 : ${this.count.sms.good.length}건\n문자 전송 실패 : ${this.count.sms.bad.length}건`
        );
      }

      const toContactMailList = this.count.mail.good;
      const toContactTelList = this.count.sms.good;
      const idx = estimate_list[0].idx;
      const schoolCode = this.schoolcode;

      const senddata = { schoolCode, idx, toContactMailList, toContactTelList };

      console.log(senddata);

      this.count.mail.good = [];
      this.count.mail.bad = [];
      this.count.sms.good = [];
      this.count.sms.bad = [];

      const res2 = await this.$store.dispatch("SEND_ESTIMATE", senddata);

      if (res2.data.result) {
        alert("견적 발송 완료 처리되었습니다.");
      }

      if (this.estimate_idx) {
        if (window.confirm("견적을 초기화하시겠습니까?")) {
          this.schoolname = "";
          this.plan = "";
          this.estimateinit();
        }
      }
    },
    async schoolsearch() {
      if (this.searchdata[this.searchschool]) {
        let regex = /^[a-zA-Z0-9]*$/;

        if (regex.test(this.searchschool)) {
          this.schoolcode = this.searchschool;
          this.searchschool = this.searchdata[this.searchschool];
        } else {
          this.schoolcode = this.searchdata[this.searchschool];
        }

        alert(
          `학교 이름 : ${this.searchschool}\n학교 코드 : ${this.schoolcode}\n설정되었습니다.`
        );

        this.estimatelist = await this.$store.dispatch(
          "GET_ESTIMATE",
          this.schoolcode
        );

        for (let i = 0; i < this.estimatelist.length; i++) {
          this.estimatelist[i].isSelected = false;
        }

        this.contactlist = await this.$store.dispatch(
          "GET_SCHOOL_CONTACT",
          this.schoolcode
        );

        return;
      } else {
        this.searchschool = "";
        this.schoolcode = "";
        alert("학교 정보가 존재하지 않습니다.");
      }
    },
    getplanstring(str) {
      if (str == "premium") {
        return "프리미엄";
      } else if (str == "general") {
        return "일반";
      } else {
        return "-";
      }
    },
    getlocalestring(num) {
      return num.toLocaleString();
    },
    getestimatetime(arr) {
      return arr.join("\n");
    },
  },
};
</script>

<style scoped>
.page-wrap {
  display: flex;
  flex-direction: column;
  gap: var(--space-6);
}

/* 필드 공통 */
.field-group {
  margin-bottom: var(--space-5);
}
.field-group:last-child {
  margin-bottom: 0;
}

.field-label {
  display: block;
  margin-bottom: var(--space-2);
  font-size: var(--font-body-strong-size);
  line-height: var(--font-body-strong-line);
  font-weight: var(--font-body-strong-weight);
  color: var(--text-primary);
}

.field-required {
  margin-left: var(--space-1);
  color: var(--color-error-text, #B42318);
  font-weight: 400;
  font-size: var(--font-small-size);
}

.field-helper {
  margin: var(--space-1) 0 0;
  font-size: var(--font-small-size);
  line-height: var(--font-small-line);
  color: var(--text-tertiary);
}

.field-error {
  display: flex;
  align-items: center;
  gap: var(--space-1);
  margin: var(--space-1) 0 0;
  font-size: var(--font-small-size);
  color: var(--color-error-text, #B42318);
}

.btn-primary { font-weight: 600; }
.btn-secondary { font-weight: 500; }

/* 학교 검색 */
.search-row {
  display: flex;
  flex-wrap: wrap;
  gap: var(--space-2);
  align-items: center;
}
.search-row__input {
  flex: 1 1 280px;
  max-width: 450px;
}

/* 견적 내용 폼 */
.form-row {
  display: flex;
  flex-wrap: wrap;
  gap: var(--space-5);
}
.field-group--inline {
  flex: 1 1 220px;
  min-width: 200px;
  margin-bottom: 0;
}

/* 견적 결과 */
.result-row {
  display: flex;
  flex-wrap: wrap;
  gap: var(--space-3);
  align-items: center;
}
.result-row__amount {
  flex: 0 0 300px;
  max-width: 300px;
}
.result-row__desc {
  flex: 1 1 280px;
  color: var(--text-secondary);
  font-size: var(--font-small-size);
  line-height: 1.6;
}
.result-row__line {
  margin: 0;
}
.result-row__line .num {
  font-variant-numeric: tabular-nums;
  font-weight: 600;
  color: var(--text-primary);
}

.final-row {
  display: flex;
  align-items: center;
  gap: var(--space-3);
}
.final-row__amount {
  flex: 0 0 320px;
  max-width: 320px;
}

/* 결과 테이블 */
.info-table-wrap {
  overflow-x: auto;
  border: 1px solid var(--border-default);
  border-radius: var(--radius-sm);
}

.info-table {
  width: 100%;
  min-width: 600px;
  border-collapse: collapse;
  font-size: var(--font-body-size);
  line-height: var(--font-body-line);
  color: var(--text-primary);
  background: var(--bg-surface);
}

.info-table thead th {
  padding: var(--space-3) var(--space-4);
  background: var(--bg-subtle);
  color: var(--text-secondary);
  font-size: var(--font-body-strong-size);
  font-weight: var(--font-body-strong-weight);
  text-align: center;
  border-bottom: 1px solid var(--border-default);
  white-space: nowrap;
}

.info-table tbody td {
  padding: var(--space-3) var(--space-4);
  border-bottom: 1px solid var(--border-default);
  text-align: center;
  white-space: nowrap;
}

.info-table tbody tr:last-child td {
  border-bottom: none;
}

.info-table td.num {
  text-align: right;
  font-variant-numeric: tabular-nums;
}

.info-table td.num.strong {
  font-weight: 600;
  color: var(--text-primary);
}

.info-table td.mono {
  font-family: var(--font-mono-family, "JetBrains Mono", "D2Coding", monospace);
  font-size: var(--font-mono-size, 13px);
}

.empty-row {
  padding: var(--space-6);
  color: var(--text-tertiary);
  font-size: var(--font-small-size);
  text-align: center;
}

/* PDF 미리보기 영역 (백엔드 HTML — 손대지 말 것) */
.preview-wrap {
  background: var(--bg-surface);
  border: 1px solid var(--border-default);
  border-radius: var(--radius-md);
  padding: var(--space-4);
}
.preview-label {
  margin: 0 0 var(--space-2);
  font-size: var(--font-small-size);
  color: var(--text-tertiary);
}

/* 알림 다이얼로그 */
.alert-dialog {
  display: flex;
  flex-direction: column;
}
.alert-dialog__header {
  padding: var(--space-4) var(--space-5);
  background: var(--color-primary-600);
  color: #fff;
  font-size: var(--font-h3-size);
  font-weight: var(--font-h3-weight);
}
.alert-dialog__body {
  padding: var(--space-5);
  font-size: var(--font-body-size);
  line-height: 1.6;
  color: var(--text-primary);
}
.alert-dialog__body p {
  margin: 0;
}
.alert-dialog__footer {
  display: flex;
  justify-content: flex-end;
  gap: var(--space-2);
  padding: 0 var(--space-5) var(--space-5);
}

/* 모바일 */
@media (max-width: 600px) {
  .result-row__amount,
  .final-row__amount {
    flex: 1 1 100%;
    max-width: 100%;
  }
}
</style>
